export default __webpack_public_path__ + "static/media/partner-blast-royal.15bbe0b3.png";